import { useSetAtom } from 'jotai';

import * as state from '../../../_state/bookingForm.state';

import { FileMutations } from '~/modules/trade/types/file';

export const useBookingFiles = (): FileMutations => {
  const createFile = useSetAtom(state.$createBookingFile);
  const confirmFileUpload = useSetAtom(state.$confirmBookingFileUpload);
  const deleteFile = useSetAtom(state.$deleteBookingFile);

  return {
    createFile: async (params) => {
      const result = await createFile({
        fileName: params.fileName,
        mimeType: params.mimeType,
        bookingId: params.entityId,
        fileSize: params.fileSize,
      });

      return {
        id: result.tradeBookingFileCreate.file.id,
        uploadUrl: result.tradeBookingFileCreate.uploadUrl ?? '',
      };
    },
    confirmUpload: async (params) => {
      await confirmFileUpload({ fileId: params.fileId });

      return {
        url: '', // No download URL available from confirm upload, will use download hook when needed
      };
    },
    deleteFile: async (params) => {
      await deleteFile({ fileId: params.fileId });
    },
  };
};
